<span class="title-text">
    {{ 'aumico_project_reports_switch_to_automatic_transfer_of_annual_result_title' | i18next }}
</span>

<div class="dialog-container">
    <!-- Dialog content -->
    <div class="dialog-content">
        <span class="description-text">
            {{ 'aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description' | i18next }}
        </span>

        <!-- Warning/Info section -->
        <div class="info-section">
            <span class="ham-icon info-icon">
                <i class="info-outline-icon"></i>
            </span>
            <div class="info-content">
                <span class="info-text">
                    {{ 'aumico_project_reports_switch_to_automatic_transfer_of_annual_result_info_text' | i18next }}
                </span>
            </div>
        </div>
    </div>
</div>
